type ContentType = {
  [key: number]: {
    background: string;
    text: string | JSX.Element;
  };
};

export const PrizeCoverImage = ({
  tabTable,
  isPrimary,
}: {
  tabTable: number;
  isPrimary: boolean;
}) => {
  const primaryContent: ContentType = {
    0: {
      background: "bg-[url('/assets/images/pelota_primaria.png')]",
      text: (
        <>
          ¡El DT ganador de la fecha se <br /> lleva una pelota de fútbol!
        </>
      ),
    },
    1: {
      background: "bg-[url('/assets/images/camiseta_primaria.png')]",
      text: (
        <>
          ¡El DT ganador del torneo se <br /> lleva un smartphone!
        </>
      ),
    },
  };

  const secondaryContent: ContentType = {
    0: {
      background: "bg-[url('/assets/images/premio_secundaria_1.png')]",
      text: (
        <>
          ¡El DT ganador de la fecha se <br /> lleva una pelota de fútbol!
        </>
      ),
    },
    1: {
      background: "bg-[url('/assets/images/premio_secundaria_2.png')]",
      text: (
        <>
          ¡El DT ganador del torneo se <br /> lleva un Smart TV!
        </>
      ),
    },
  };

  const content = isPrimary ? primaryContent : secondaryContent;

  return (
    <div
      key={tabTable}
      className={`flex items-center justify-center w-full h-[144px] text-white ${content[tabTable].background} bg-contain bg-no-repeat rounded-lg my-4`}
    >
      <div className="w-[500px] text-center">
        <h2 className="text-[32px] font-normal uppercase leading-relaxed font-bebas">
          {content[tabTable].text}
        </h2>
      </div>
    </div>
  );
};
